import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../_services/auth.service';
import { AppComponent } from 'src/app/app.component';
import { HomeComponent } from '../home.component';
declare var $;

@Component({
  selector: 'app-pending-email-verification',
  templateUrl: './pending-email-verification.component.html',
  styleUrls: ['./pending-email-verification.component.css']
})
export class PendingEmailVerificationComponent implements OnInit {

  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', {static: true}) table;

  constructor(private authService: AuthService, private appComponent: AppComponent, private homeComponent: HomeComponent) { }

  ngOnInit() {
    this.authService.isAuthenticated();
    this.appComponent.setTitle('Pending Email Verification');

    this.authService.pageVisit().subscribe(() => {
    }, error => {
        console.log(error);
    });

    this.getDataForPendingEmailVerification();
  }

  SetInactive() {
    this.homeComponent.SetInactive();
  }

  getDataForPendingEmailVerification() {

    this.authService.pendingemailverification().subscribe(data => {
      data.pev.forEach((value, index) => {
        value.index = index + 1;
      });
      this.tableData = data.pev;
      this.dtOptions = {
        data: this.tableData,
        columns: [
          {title: '#', data: 'index'},
          {title: 'Email', data: 'email'},
          {title: 'Role Type', data: 'uType'}
        ],
        responsive: true,
        autoWidth: false
      };
    }, err => {
      console.log(err);
    }, () => {
      this.dataTable = $(this.table.nativeElement);
      this.dataTable.DataTable(this.dtOptions);
    });
  }
}
